// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f04dc3a2","453":"65286e8a"}[chunkId] + ".chunk.js";
};